import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import CambiaPassword from "@/pages/CambiaPassword";
import ResetPassword, { PasswordDimenticata } from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import HomePage from "@/pages/HomePage";
import CommercialeHome from "@/pages/CommercialeHome";
import ClassificheDealer from "@/pages/ClassificheDealer";
import ClassificheDealerMensili from "@/pages/ClassificheDealerMensili";
import Performance from "@/pages/Performance";
import Monitoraggio from "@/pages/Monitoraggio";
import PaginaCustom from "@/pages/PaginaCustom";
import Archivio from "@/pages/Archivio";
import MappaConvenzionati from "@/pages/MappaConvenzionati";
import Convenzionati from "@/pages/Convenzionati";
import DealerDetail from "@/pages/DealerDetail";
import Pratiche from "@/pages/Pratiche";
import PraticaDetail from "@/pages/PraticaDetail";
import PerformanceCommerciali from "@/pages/PerformanceCommerciali";
import PraticheGiornaliere from "@/pages/PraticheGiornaliere";
import Importazioni from "@/pages/Importazioni";
import Utenti from "@/pages/Utenti";
import DashboardCq from "@/pages/DashboardCq";
import CalendarioCq from "@/pages/CalendarioCq";
import ElencoCq from "@/pages/ElencoCq";
import StoricoChat from "@/pages/StoricoChat";
import LayoutCq from "@/components/LayoutCq";
import MonitoraggioDbe from "@/pages/MonitoraggioDbe";
import MercatoBenchmark from "@/pages/MercatoBenchmark";
import CalendarioCorto from "@/pages/CalendarioCorto";
import Documenti from "@/pages/Documenti";
import MappaZonaPage from "@/pages/MappaZonaPage";
import CommercialeGiornaliero from "@/pages/CommercialeGiornaliero";
import PortafoglioSviluppo from "@/pages/PortafoglioSviluppo";
import AnalisiPortafoglio from "@/pages/AnalisiPortafoglio";
import NotificaPush from "@/pages/NotificaPush";
import Impostazioni from "@/pages/Impostazioni";
import FormuleGrafici from "@/pages/FormuleGrafici";
import ProiezioniImpostazioni from "@/pages/ProiezioniImpostazioni";
import SceltaCanale from "@/pages/SceltaCanale";
import CanaleCorto from "@/pages/CanaleCorto";
import AgenziaCorto from "@/pages/AgenziaCorto";
import ClassificheCorto from "@/pages/ClassificheCorto";
import TassiPremi from "@/pages/TassiPremi";
import AnalisiTelefonate from "@/pages/AnalisiTelefonate";
import ReportAgenzia from "@/pages/ReportAgenzia";
import ConfigurazioniCorto from "@/pages/ConfigurazioniCorto";
import News from "@/pages/News";
import NewsArticolo from "@/pages/NewsArticolo";

// prima pagina utile in base ai permessi: il punto di ingresso e' sempre il primo
// elemento consentito nell'ordine del menu, per qualunque ruolo (Master compreso)
const ROTTE_CORTO = [
  ["corto_dashboard", "/canale-corto"],
  ["corto_tassi", "/canale-corto/tassi-premi"],
  ["corto_classifiche_caricato", "/canale-corto/classifiche/caricato"],
  ["corto_classifiche_liquidato", "/canale-corto/classifiche/liquidato"],
  ["corto_classifiche_tassi", "/canale-corto/classifiche/tassi"],
  ["corto_telefonate", "/canale-corto/telefonate"],
  ["corto_report_agenzia", "/canale-corto/report-agenzia"],
  ["corto_configurazioni", "/canale-corto/configurazioni"],
  ["corto_utenti", "/canale-corto/utenti"],
];

const ROTTE_PAGINE = [
  ["home", "/"],
  ["giornaliero", "/giornaliero"],
  ["pratiche", "/pratiche"],
  ["convenzionati", "/convenzionati"],
  ["classifiche", "/classifiche-convenzionati"],
  ["mappa", "/mappa-convenzionati"],
  ["performance", "/performance"],
  ["news", "/news"],
  ["importazioni", "/importazioni"],
  ["utenti", "/utenti"],
  ["impostazioni", "/impostazioni"],
  ["formule", "/formule-grafici"],
  ["archivio", "/archivio"],
];

function Shell() {
  const { user, loading, can } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  // la scelta del canale vale per la sessione del browser: alla riapertura del sito si richiede
  const [canale, setCanale] = useState(() => sessionStorage.getItem("dbe_canale") || "");
  const scegliCanale = (k) => {
    sessionStorage.setItem("dbe_canale", k);
    setCanale(k);
  };
  // pagina iniziale scelta dall'utente: si applica una sola volta per sessione, all'apertura
  const avvio = user?.pagina_iniziale && !sessionStorage.getItem("dbe_avvio") && user.id !== "guest"
    && !user.must_change_password ? user.pagina_iniziale : null;
  useEffect(() => {
    if (!avvio) return;
    sessionStorage.setItem("dbe_avvio", "1");
    const trasversale = ["/monitoraggio-dbe", "/mercato-benchmark", "/calendario-corto", "/dashboard-cq", "/calendario-cq", "/elenco-cq"].includes(avvio);
    if (!trasversale) {
      const k = avvio.startsWith("/canale-corto") ? "corto" : "lungo";
      if ((user.canali || ["lungo"]).includes(k)) scegliCanale(k);
    }
    if (location.pathname !== avvio) navigate(avvio, { replace: true });
  }, [avvio]); // eslint-disable-line react-hooks/exhaustive-deps
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-slate-500">Caricamento…</div>;
  if (!user) {
    return (
      <Routes>
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  if (["/dashboard-cq", "/calendario-cq", "/elenco-cq"].includes(location.pathname)) {
    // area CQ autonoma con tendina laterale propria
    if (!can("report_cq")) return <Navigate to="/scelta-canale" replace />;
    if (user.must_change_password) return <CambiaPassword />;
    return (
      <Routes>
        <Route element={<LayoutCq />}>
          <Route path="/dashboard-cq" element={<DashboardCq />} />
          <Route path="/calendario-cq" element={<CalendarioCq />} />
          <Route path="/elenco-cq" element={<ElencoCq />} />
        </Route>
      </Routes>
    );
  }
  if (location.pathname === "/procedure" || location.pathname === "/inxpire") {
    // aree documentali autonome (PROCEDURE / INXPIRE), raggiungibili dalla scelta iniziale
    const sez = location.pathname.slice(1);
    return can(sez) ? (
      <div className="min-h-screen px-4 sm:px-6 py-8" style={{ background: "#F5F7FA" }}>
        <div className="max-w-[1400px] mx-auto"><Documenti sezione={sez} /></div>
      </div>
    ) : <Navigate to="/scelta-canale" replace />;
  }
  if (location.pathname === "/calendario-corto") {
    // area autonoma: nessun menu di canale, si raggiunge solo dalla scelta iniziale
    return can("calendario_corto") ? (
      <div className="min-h-screen px-4 sm:px-6 py-8" style={{ background: "#F5F7FA" }}>
        <div className="max-w-[1800px] mx-auto"><CalendarioCorto /></div>
      </div>
    ) : <Navigate to="/scelta-canale" replace />;
  }
  if (user.must_change_password) return <CambiaPassword />;
  const canali = user.canali || ["lungo"];
  const attivo = canali.includes(canale) ? canale : (canali.length === 1 ? canali[0] : "");
  if (!attivo) {
    return (
      <Routes>
        {can("monitoraggio_globale") && (
          <Route path="/monitoraggio-dbe" element={
            <div className="min-h-screen px-6 py-8" style={{ background: "#F5F7FA" }}>
              <div className="max-w-[1800px] mx-auto"><MonitoraggioDbe /></div>
            </div>} />
        )}
        {can("benchmark") && (
          <Route path="/mercato-benchmark" element={
            <div className="min-h-screen px-6 py-8" style={{ background: "#F5F7FA" }}>
              <div className="max-w-[1500px] mx-auto"><MercatoBenchmark /></div>
            </div>} />
        )}
        <Route path="*" element={<SceltaCanale onScegli={scegliCanale} />} />
      </Routes>
    );
  }
  if (attivo === "corto") {
    const paginaCorto = (ROTTE_CORTO.find(([chiave]) => can(chiave)) || [null, "/account"])[1];
    return (
      <Routes>
        <Route path="/scelta-canale" element={<SceltaCanale onScegli={scegliCanale} />} />
        <Route element={<Layout canale="corto" onCambiaCanale={() => scegliCanale("")} />}>
          {can("corto_dashboard") && <Route path="/canale-corto" element={<CanaleCorto />} />}
          {can("corto_agenzie") && <Route path="/canale-corto/agenzie/:slug" element={<AgenziaCorto />} />}
          {can("corto_tassi") && <Route path="/canale-corto/tassi-premi" element={<TassiPremi />} />}
          {can("corto_tassi") && <Route path="/canale-corto/agenzie/:slug/tassi-premi" element={<TassiPremi />} />}
          <Route path="/canale-corto/classifiche" element={<Navigate to="/canale-corto/classifiche/caricato" replace />} />
          {["caricato", "liquidato", "tassi"].filter((v) => can(`corto_classifiche_${v}`)).map((v) => (
            <Route key={v} path={`/canale-corto/classifiche/${v}`} element={<ClassificheCorto vista={v} />} />
          ))}
          {can("corto_telefonate") && <Route path="/canale-corto/telefonate" element={<AnalisiTelefonate />} />}
          {can("corto_report_agenzia") && <Route path="/canale-corto/report-agenzia" element={<ReportAgenzia />} />}
          {can("corto_configurazioni") && <Route path="/canale-corto/configurazioni" element={<ConfigurazioniCorto />} />}
          {can("corto_configurazioni") && <Route path="/canale-corto/proiezioni" element={<ProiezioniImpostazioni />} />}
          {can("corto_utenti") && <Route path="/canale-corto/utenti" element={<Utenti />} />}
          {can("monitoraggio_globale") && <Route path="/monitoraggio-dbe" element={<MonitoraggioDbe />} />}
          {can("benchmark") && <Route path="/mercato-benchmark" element={<MercatoBenchmark />} />}
          {can("impostazioni") && <Route path="/impostazioni" element={<Impostazioni />} />}
          <Route path="/account" element={<Account />} />
          <Route path="/storico-chat" element={<StoricoChat />} />
          <Route path="/notifica/:id" element={<NotificaPush />} />
          <Route path="*" element={<Navigate to={paginaCorto} replace />} />
        </Route>
      </Routes>
    );
  }
  const paginaIniziale = (ROTTE_PAGINE.find(([chiave]) => can(chiave)) || [null, "/account"])[1];
  return (
    <Routes>
      <Route path="/scelta-canale" element={<SceltaCanale onScegli={scegliCanale} />} />
      <Route element={<Layout canale="lungo"
        onCambiaCanale={canali.length > 1 ? () => scegliCanale("") : null} />}>
        <Route path="/canale-corto" element={can("corto_dashboard")
          ? <CanaleCorto /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/agenzie/:slug" element={can("corto_agenzie")
          ? <AgenziaCorto /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/tassi-premi" element={can("corto_tassi")
          ? <TassiPremi /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/agenzie/:slug/tassi-premi" element={can("corto_tassi")
          ? <TassiPremi /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/classifiche" element={canali.includes("corto")
          ? <Navigate to="/canale-corto/classifiche/caricato" replace />
          : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/classifiche/:vista" element={<ClassificheCorto />} />
        <Route path="/canale-corto/telefonate" element={can("corto_telefonate")
          ? <AnalisiTelefonate /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/report-agenzia" element={can("corto_report_agenzia")
          ? <ReportAgenzia /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/configurazioni" element={can("corto_configurazioni")
          ? <ConfigurazioniCorto /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/canale-corto/utenti" element={can("corto_utenti")
          ? <Utenti /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/monitoraggio-dbe" element={can("monitoraggio_globale")
          ? <MonitoraggioDbe /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/mercato-benchmark" element={can("benchmark")
          ? <MercatoBenchmark /> : <Navigate to={paginaIniziale} replace />} />
        <Route path="/account" element={<Account />} />
        <Route path="/notifica/:id" element={<NotificaPush />} />
        <Route path="/" element={can("home") ? <HomePage /> : <Navigate to={paginaIniziale} replace />} />
        {can("home") && <Route path="/classifiche-dealer" element={<ClassificheDealerMensili />} />}
        {can("home") && <Route path="/performance-scostamenti" element={<Performance />} />}
        {can("home") && <Route path="/portafoglio-sviluppo" element={<PortafoglioSviluppo />} />}
        {can("analisi_portafoglio") && <Route path="/analisi-portafoglio" element={<AnalisiPortafoglio />} />}
        {can("home") && <Route path="/monitoraggio" element={<Monitoraggio />} />}
        {can("archivio") && <Route path="/archivio" element={<Archivio />} />}
        <Route path="/p/:slug" element={<PaginaCustom />} />
        {can("commerciali") && <Route path="/commerciali/:comm/p/:slug" element={<PaginaCustom />} />}
        {can("commerciali") && <Route path="/commerciali/:slug/performance" element={<Performance />} />}
        {can("commerciali") && <Route path="/commerciali/:slug/portafoglio-sviluppo" element={<PortafoglioSviluppo />} />}
        {can("commerciali") && can("analisi_portafoglio") && <Route path="/commerciali/:slug/analisi-portafoglio" element={<AnalisiPortafoglio />} />}
        {can("commerciali") && <Route path="/commerciali/:slug" element={<CommercialeHome />} />}
        {can("commerciali") && <Route path="/commerciali/:slug/giornaliero" element={<CommercialeGiornaliero />} />}
        {can("commerciali") && <Route path="/commerciali/:slug/mappa-zona" element={<MappaZonaPage />} />}
        {can("commerciali") && <Route path="/commerciali/:slug/classifiche-dealer" element={<ClassificheDealerMensili />} />}
        {can("convenzionati") && <Route path="/convenzionati" element={<Convenzionati />} />}
        {can("mappa") && <Route path="/mappa-convenzionati" element={<MappaConvenzionati />} />}
        {can("classifiche") && <Route path="/classifiche-convenzionati" element={<ClassificheDealer />} />}
        {can("convenzionati") && <Route path="/convenzionati/:codice" element={<DealerDetail />} />}
        {can("pratiche") && <Route path="/pratiche" element={<Pratiche />} />}
        <Route path="/storico-chat" element={<StoricoChat />} />
        {can("pratiche") && <Route path="/pratiche/:numero" element={<PraticaDetail />} />}
        {can("performance") && <Route path="/performance" element={<PerformanceCommerciali />} />}
        {can("news") && <Route path="/news" element={<News />} />}
        {can("news") && <Route path="/news/:slug" element={<NewsArticolo />} />}
        {can("giornaliero") && <Route path="/giornaliero" element={<PraticheGiornaliere />} />}
        {can("importazioni") && <Route path="/importazioni" element={<Importazioni />} />}
        {can("utenti") && <Route path="/utenti" element={<Utenti />} />}
        {can("impostazioni") && <Route path="/impostazioni" element={<Impostazioni />} />}
        {can("formule") && <Route path="/formule-grafici" element={<FormuleGrafici />} />}
        {can("impostazioni") && <Route path="/impostazioni/proiezioni" element={<ProiezioniImpostazioni />} />}
        <Route path="*" element={<Navigate to={paginaIniziale} replace />} />
      </Route>
    </Routes>
  );
}

function ScrollInAlto() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollInAlto />
        <Shell />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
